import Bugsnag from '@bugsnag/js';

if (process.env.NODE_ENV !== 'development') {
  Bugsnag.start({
    apiKey: process.env.js_bugsnag_api_key,
    releaseStage: process.env.RAILS_ENV,
  });
};
